import _classPrivateFieldLooseBase from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldLooseBase.js";
import _classPrivateFieldLooseKey from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldLooseKey.js";
var _online, _cleanup, _setup;
// src/onlineManager.ts
import { Subscribable } from "./subscribable.js";
import { isServer } from "./utils.js";
var OnlineManager = (_online = /*#__PURE__*/_classPrivateFieldLooseKey("online"), _cleanup = /*#__PURE__*/_classPrivateFieldLooseKey("cleanup"), _setup = /*#__PURE__*/_classPrivateFieldLooseKey("setup"), class OnlineManager extends Subscribable {
  constructor() {
    super();
    Object.defineProperty(this, _online, {
      writable: true,
      value: true
    });
    Object.defineProperty(this, _cleanup, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _setup, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _setup)[_setup] = onOnline => {
      if (!isServer && window.addEventListener) {
        const onlineListener = () => onOnline(true);
        const offlineListener = () => onOnline(false);
        window.addEventListener("online", onlineListener, false);
        window.addEventListener("offline", offlineListener, false);
        return () => {
          window.removeEventListener("online", onlineListener);
          window.removeEventListener("offline", offlineListener);
        };
      }
      return;
    };
  }
  onSubscribe() {
    if (!_classPrivateFieldLooseBase(this, _cleanup)[_cleanup]) {
      this.setEventListener(_classPrivateFieldLooseBase(this, _setup)[_setup]);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _classPrivateFieldLoo, _classPrivateFieldLoo2;
      (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _cleanup))[_cleanup]) === null || _classPrivateFieldLoo === void 0 || _classPrivateFieldLoo.call(_classPrivateFieldLoo2);
      _classPrivateFieldLooseBase(this, _cleanup)[_cleanup] = void 0;
    }
  }
  setEventListener(setup) {
    var _classPrivateFieldLoo3, _classPrivateFieldLoo4;
    _classPrivateFieldLooseBase(this, _setup)[_setup] = setup;
    (_classPrivateFieldLoo3 = (_classPrivateFieldLoo4 = _classPrivateFieldLooseBase(this, _cleanup))[_cleanup]) === null || _classPrivateFieldLoo3 === void 0 || _classPrivateFieldLoo3.call(_classPrivateFieldLoo4);
    _classPrivateFieldLooseBase(this, _cleanup)[_cleanup] = setup(this.setOnline.bind(this));
  }
  setOnline(online) {
    const changed = _classPrivateFieldLooseBase(this, _online)[_online] !== online;
    if (changed) {
      _classPrivateFieldLooseBase(this, _online)[_online] = online;
      this.listeners.forEach(listener => {
        listener(online);
      });
    }
  }
  isOnline() {
    return _classPrivateFieldLooseBase(this, _online)[_online];
  }
});
var onlineManager = new OnlineManager();
export { OnlineManager, onlineManager };